import { OfferActionTypes, All } from '../actions/offerActions';


export interface State {
  errorMessage: string | null;
  successMessage: string | null;
  success : boolean,
  error: string | null;
  action: string;
  viewOffer;
  changeStatusObject;
  request;
}

const initialState: State = {
  errorMessage: null,
  successMessage: null,
  success: null,
  error:null,
  action: '',
  viewOffer:null,
  changeStatusObject:null,
  request:null
};

export function offerReducer(state:State=initialState, action: All): State {
  
  switch (action.type) {
    
    case OfferActionTypes.DEFAULT_OFFER_STATE: {
      return initialState;
    }
    
    case OfferActionTypes.OFFER_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        viewOffer:action.payload.data,
        action: 'view-offer'
      };
    }
    case OfferActionTypes.OFFER_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        viewOffer: '',
        action: 'view-offer'
      };
    }
    case OfferActionTypes.OFFER_STATUS_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        changeStatusObject:action.payload.data,
        action: 'change-offer-status',
        
      };
    }
    case OfferActionTypes.OFFER_STATUS_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        changeStatusObject: '',
        action: 'change-offer-status'
      };
    }
    case OfferActionTypes.REQUEST_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        success: action.payload.success,
        request:action.payload.data,
        action: 'view-request'
        
      };
    }
    case OfferActionTypes.REQUEST_FAILURE : {
      return {
        ...state,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        request:'',
        action: 'view-request',
        
      };
    }
    default: {
      return state;
    }
  }
}
